import React from 'react';
import { Breadcrumbs } from '@src/abyss/web/ui/Breadcrumbs';
import { RouteUrl } from '@src/common/util/routeUrl';
import { constants } from '@src/routes/provider/common/constants';

export const RiskScoresBreadcrumbs = () => {
  return (
    <Breadcrumbs
      items={[
        { title: 'Home', href: '/' },
        { title: constants.PageTitles.riskScores, href: RouteUrl.riskScores },
      ]}
    />
  );
};
